import React, { useState, useEffect } from "react";
import Axios from "axios";
import { portal_url } from "../utils/Api";
// import { Carousel } from "react-responsive-carousel";
// import { getDateTime } from "../utils/dateTime";

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  // CarouselIndicators,
  // CarouselCaption,
} from "reactstrap";

const Banner = (args) => {
  useEffect(() => {
    const timeout = setTimeout(() => getBanner(), 1000);
    return () => clearTimeout(timeout);
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  const [windowSize] = useState(getWindowSize());
  const [image, setImage] = useState([]);

  const hitungSize = () => {
    if (windowSize.innerWidth > 780 && windowSize.innerWidth <= 1600) {
      return windowSize.innerHeight / 1.9 + "px";
    } else if (windowSize.innerWidth > 1600) {
      return "380px";
    } else {
      return windowSize.innerHeight / 4 + "px";
    }
  };

  const getBanner = async () => {
    await Axios.get(`${portal_url}/api/banner`)
      .then((res) => {
        const data = res.data.message.data;
        setImage(data);
      })
      .catch((error) => {});
  };

  // const items = [
  //   {
  //     src: "https://picsum.photos/id/123/1200/400",
  //     altText: "Slide 1",
  //     caption: "Slide 1",
  //     key: 1,
  //   },
  //   {
  //     src: "https://picsum.photos/id/456/1200/400",
  //     altText: "Slide 2",
  //     caption: "Slide 2",
  //     key: 2,
  //   },
  //   {
  //     src: "https://picsum.photos/id/678/1200/400",
  //     altText: "Slide 3",
  //     caption: "Slide 3",
  //     key: 3,
  //   },
  // ];

  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === image.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? image.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  // const goToIndex = (newIndex) => {
  //   if (animating) return;
  //   setActiveIndex(newIndex);
  // };

  const slides = image.map((item, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={index}
      >
        {item.url_link === null ? (
          <img
            src={item.file}
            alt={item.name}
            style={{
              borderRadius: "12px",
              height: hitungSize(),
            }}
          />
        ) : (
          <a
            href={item.url_link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inherit" }}
          >
            <img
              src={item.file}
              alt={item.name}
              style={{
                borderRadius: "12px",
                height: hitungSize(),
              }}
            />
          </a>
        )}
        {/* <CarouselCaption
          captionText={item.caption}
          captionHeader={item.caption}
        /> */}
      </CarouselItem>
    );
  });

  return (
    <>
      {image.length > 0 ? (
        <Carousel
          style={{
            width: "100%",
            boxShadow: "rgba(227, 227, 227, 0.78) 0px 5px 10px 10px",
            borderRadius: "12px",
          }}
          ride={"carousel"}
          activeIndex={activeIndex}
          next={next}
          previous={previous}
          {...args}
        >
          {/* <CarouselIndicators
            items={image}
            activeIndex={activeIndex}
            onClickHandler={goToIndex}
          /> */}

          {slides}
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={previous}
          />
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={next}
          />
        </Carousel>
      ) : (
        <div
          style={{
            width: "100%",
            height: hitungSize(),
            boxShadow: "rgba(227, 227, 227, 0.78) 0px 5px 10px 10px",
            borderRadius: "12px",
          }}
        ></div>
      )}
    </>
  );
};

export default Banner;
